export class InverterSearchModel {
  Skip?: number;
  Take?: number;
  Search?: string;
  Id?: number;
  Manufacturer?: string;
  ModelNumber?: string;
  VersionNumber?: string;
  IEEE1547Certified?: boolean;
  VoltageRating?: number;
  DCSourceRating?: number;
  NominalDCVoltage?: number;
  PowerFactor?: number;
  Frequency?: number;
  kWRating?: number;
  kVARating?: number;
  RatingCircuitVoltage?: number;
  InverterPhaseConnection?: string;
  PhaseType?: string;
  UL1741CertificationDate?: Date | string;
  UnformattedManufacturer?: string;
  UnformattedModelNumber?: string;
  IsEditable?: boolean;
  IsActive?: boolean;
  AutomatedUpdatesDisabled?: boolean;

  constructor(params: Partial<InverterSearchModel> = {}) {
    Object.assign(this, params);
  }

  toUriParams(): URLSearchParams {
    const params = new URLSearchParams();

    Object.entries(this).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }

      if (value instanceof Date) {
        params.set(key, value.toISOString());
        return;
      }

      params.set(key, String(value));
    });

    return params;
  }
}
